export const isZipfileIOEnabled = () => {
	const url = new URL(location.href)
	return url.searchParams.get("zipfile-io-enabled") === "1"
}

/**
 * OPFS directory name to import from when `zipfile-io-enabled=1` is set
 * (which gates both the ZIP-import and the "Use OPFS Entry" buttons in the
 * Create Project dialog). Defaults to "perf-import"; can be overridden via
 * `?opfs-import-dir=<name>` to keep multiple perf datasets side-by-side.
 */
export const getOpfsImportDir = () => {
	const url = new URL(location.href)
	return url.searchParams.get("opfs-import-dir") || "perf-import"
}
